module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowledgements",
    attrs: {
      "id": "acknowledgements"
    }
  }, [_c('p', {
    staticClass: "Chapter_Title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "chapImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/chapicon.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("This book could not have been completed without the invaluable support of three of Carlisle’s local historians, Denis Perriam, Ashley Kendall and Mike Milbourn, who generously shared information and provided illustrations; Denis also kindly read and commented on a draft of the book. Stephen White at Carlisle City Library willingly answered questions and provided difficult to find sources. Dr Chris Brader at Cumbria archive in Carlisle shared his article on cinema in Carlisle and with his colleagues gave advice and guidance. Andrew Carter of BBC Cumbria collaborated with me to find information. Patrick Brennan’s research on the munitonettes football teams was a superb source. Sheila Ruddick and her colleagues at the Devil’s Porridge factory museum at Eastriggs clarified obscure points about life in the munitions factory. Sue Light, a member of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Great War Forum")]), _vm._v(", provided details about the management of hospitals. I am also grateful to the editor of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cumberland News")]), _vm._v(" for permission to use pictures and adverts from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Carlisle Journal")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Robin Acland of U3A and Richard Preston shared ideas and information about the county which helped to set my reading into a wider context. John Hughes, a friend and neighbour, revealed that his grandparents met at Gretna and provided previously unpublished pictures and material.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As ever my long-suffering wife, Jan, gave unstinting support and acted as a sounding board.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Roni Wilkinson at Pen and Sword gave me the opportunity to widen my knowledge and supported the publication. Irene Moore again edited my work with care and good humour, thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("My apologies to anyone I have missed in individual thanks. I have attempted to verify all the facts of the story and any errors are my responsibility.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85d764d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_acknowledgements.vue
// module id = 69
// module chunks = 0